import { Box, Button, Stack, Typography, useTheme, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "constants/RoutePaths";
import { useContext } from "react";
import { MyTrainingsViewContext } from "context/myTrainings/MyTrainingsViewContext";
import { EmptyUserAvatar } from "components/EmptyUserAvatar/EmptyUserAvatar";
import { useNavigate } from "react-router-dom";
import { WelcomeTypography, SubtitleTypography, EditProfileButton } from "./HeaderSection.styles";

const StyledUserAvatar = styled('img')({
  height: '80px',
  width: '80px',
  borderRadius: '100%',
  objectFit: 'cover'
});

export const HeaderSection = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const { user, isStatisticOfLoggedUser } = useContext(MyTrainingsViewContext);

    const handleEditProfileClick = () => {
        navigate(isStatisticOfLoggedUser ? RoutePaths.PROFILE : `${RoutePaths.PROFILE}?userId=${user?.id}`);
    }

    return !user ? null : (
        <Box display='flex' flexDirection='row' justifyContent='space-between' height='20%' alignItems='end' paddingBottom={theme.spacing(4)}>
            <Stack direction='row' alignItems='center' spacing={theme.spacing(6)}>
                {user.profilePhotoUrl ? 
                    <StyledUserAvatar src={user.profilePhotoUrl} alt="User Avatar" />
                    : <EmptyUserAvatar color='black' fontSize='3em' padding={theme.spacing(2)} />
                }
                <Stack direction='column' spacing={1}>
                    <WelcomeTypography variant="h5">
                        {isStatisticOfLoggedUser ? t('myTrainings.welcomeUser', { userName: user.displayName }) : t('myTrainings.welcomeInUserProgress', { userName: user.displayName })} 
                    </WelcomeTypography>
                    <SubtitleTypography variant="h6">
                        {isStatisticOfLoggedUser ? t('myTrainings.checkYourLessons') : t('myTrainings.checkUserProgress')}
                    </SubtitleTypography>
                </Stack>
            </Stack>
            <Box>
                <EditProfileButton onClick={handleEditProfileClick} variant='outlined'>
                    {t('myTrainings.editProfile')}
                </EditProfileButton>
            </Box>
        </Box>
    );
};